var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-input-group',[_c('b-input',{on:{"input":_vm.change},model:{value:(_vm.filterValue),callback:function ($$v) {_vm.filterValue=$$v},expression:"filterValue"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }